import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import {
  CreateAccountWebhookMutation,
  CreateWebhookInput,
} from '@/gql/graphql';

const CREATE_ACCOUNT_WEBHOOK_MUTATION = graphql(`
  mutation CreateAccountWebhook($input: CreateWebhookInput!) {
    createWebhook(input: $input) {
      id
    }
  }
`);

const useCreateAccountWebhook = (
  options?: UseMutationOptions<
    CreateAccountWebhookMutation,
    unknown,
    CreateWebhookInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CREATE_ACCOUNT_WEBHOOK_MUTATION, { input });
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountWebhooks(),
      });
    },
    ...options,
  });
};

export default useCreateAccountWebhook;
